import React from "react";
import image from "../../Images/product.png";
function ProjectNav() {
  return (
    <div className="nav-projects">
      <img src={image} alt="" className="navProImg" />
      <div className="para navpro">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est laudantium
       
      </div>
    </div>
  );
}

export default ProjectNav;
